import { render, staticRenderFns } from "./TaskTemplateOneTable.vue?vue&type=template&id=b24a62f2"
import script from "./TaskTemplateOneTable.vue?vue&type=script&lang=js"
export * from "./TaskTemplateOneTable.vue?vue&type=script&lang=js"
import style0 from "./TaskTemplateOneTable.vue?vue&type=style&index=0&id=b24a62f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Fstv%2FPycharmProjects%2FcomponentDB%2Fvueapp%2Fsrc%2Fcomponents%2FProduct%2FOld%2FTaskTemplateOne%2FTaskTemplateOneTable.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports